import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/bus-outline-round.svg'
import _imports_1 from '@/assets/img/icon/arrow-circle-right-outline-blue.svg'
import _imports_2 from '@/assets/img/icon/arrow-circle-right-outline-orange.svg'
import _imports_3 from '@/assets/img/icon/truck-outline-black.svg'


const _hoisted_1 = { class: "py-3 grid sm:grid-cols-10" }
const _hoisted_2 = { class: "flex items-center sm:items-start justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "self-baseline" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "self-baseline",
    src: _imports_0,
    style: {"min-width":"40px","height":"40px"},
    alt: ""
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "sm:hidden flex justify-end"
}
const _hoisted_5 = { class: "sm:px-4" }
const _hoisted_6 = { class: "lg:flex items-center gap-4 mb-2" }
const _hoisted_7 = { class: "text-2xl font-bold self-baseline mb-2 lg:mb-0" }
const _hoisted_8 = {
  key: 0,
  class: "px-3 py-1 rounded-lg text-white background-warning"
}
const _hoisted_9 = {
  key: 1,
  class: "px-3 py-1 rounded-lg text-white background-danger"
}
const _hoisted_10 = {
  key: 2,
  class: "px-3 py-1 rounded-lg text-white background-success"
}
const _hoisted_11 = { class: "block xl:flex items-center gap-4 mb-2 md:mb-0" }
const _hoisted_12 = {
  key: 0,
  class: "flex gap-1 items-center mb-1 mb-2 md:mb-0"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"20px"}
}, null, -1)
const _hoisted_14 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_15 = {
  key: 1,
  class: "flex gap-1 items-center mb-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"20px"}
}, null, -1)
const _hoisted_17 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_18 = { class: "block xl:flex items-center gap-4" }
const _hoisted_19 = { class: "flex gap-2 items-center mb-2 md:mb-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar text-lg" }, null, -1)
const _hoisted_21 = { class: "text-grey-5 font-semibold text-sm" }
const _hoisted_22 = { class: "flex gap-2 items-center mb-2 md:mb-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-lg" }, null, -1)
const _hoisted_24 = { class: "text-grey-5 font-semibold text-sm" }
const _hoisted_25 = { class: "flex gap-2 items-center mb-2 md:mb-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"width":"20px"}
}, null, -1)
const _hoisted_27 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_28 = {
  key: 0,
  class: "hidden sm:block flex justify-end items-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "card-no-shadow mb-3" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`sm:flex ${_ctx.module === 'active-schedule' ? 'col-span-9' : 'col-span-10'}`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.module === 'active-schedule')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropDown($event, _ctx.item)))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.item.Name), 1),
              (_ctx.item.AlreadyStarted && !_ctx.moment(_ctx.moment().format('DD-MMMM-YYYY')).isAfter(_ctx.moment(_ctx.item.EndDate).format('DD-MMMM-YYYY')))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Sedang Berlangsung"))
                : (_ctx.item.IsDeleted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Dihapus"))
                  : (_ctx.moment(_ctx.moment().format('DD-MMMM-YYYY')).isAfter(_ctx.moment(_ctx.item.EndDate).format('DD-MMMM-YYYY')))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Selesai"))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.item.FirstRouteName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.item.FirstRouteName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.SecondRouteName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.item.SecondRouteName), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", _hoisted_21, _toDisplayString(`${_ctx.moment(_ctx.item.StartDate).format('DD MMMM YYYY')}`), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.item.AssignTo), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.item.Vehicle), 1)
              ])
            ])
          ])
        ], 2),
        (_ctx.module === 'active-schedule')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("i", {
                class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropDown($event, _ctx.item)))
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}